const index = () => import(/* webpackChunkName: "herb" */ './Index');

//云南省2020年工业质量品牌提升重点项目申报表
export default {
  routes: [
    {
      path: '/guide/brand/v2020/index',
      name: 'guide_brand_v2020_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/guide/brand/v2020/router.js